import { apiPost } from './apiClient';
import { buildApiUrl, API_ENDPOINTS } from '../config/apiEndpoints';

interface BillingLinkResponse {
  result: string;
}

interface SyncSubscriptionResponse {
  result: {
    general?: boolean;
    autoSearch?: boolean;
    autoNego?: boolean;
    mcp?: boolean;
  };
}

/**
 * Create a Stripe customer portal link for the current tenant
 * @returns Promise with the portal URL
 */
export const createBillingPortalLink = async (tenantId: number): Promise<BillingLinkResponse> => {
  const response = await apiPost(buildApiUrl(API_ENDPOINTS.billing.portalLink(tenantId)), {});
  return await response.json();
};

/**
 * Create a Stripe subscribe link for a tier
 * @param tier - "general" | "autoSearch" | "autoNego" | "mcp"
 * @returns Promise with the subscribe URL
 */
export const createBillingSubscribeLink = async (tenantId: number, tier: string): Promise<BillingLinkResponse> => {
  const response = await apiPost(buildApiUrl(API_ENDPOINTS.billing.subscribeLink(tenantId)), { tier });
  return await response.json();
};

/**
 * Sync subscription status with backend
 * @returns Promise with the active subscriptions
 */
export const syncSubscription = async (tenantId: number): Promise<SyncSubscriptionResponse> => {
  const response = await apiPost(buildApiUrl(API_ENDPOINTS.billing.syncSubscription(tenantId)), {});
  return await response.json();
};
